import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'savingsPlanAmount',
  standalone: true,
})
export class SavingsPlanAmountPipe implements PipeTransform {
  public transform(value: string): boolean {
    if (!value) {
      return null;
    }

    const num = Number(value);
    if (isNaN(num)) {
      return false;
    }

    const min = 1;
    const max = 500;

    if (num === max) {
      const splitted = value.split('.');
      if (splitted.length > 1 && !splitted[1]?.endsWith('0')) {
        return false;
      }
    }

    return num >= min && num <= 500;
  }
}
